import { wrapWc } from 'brinejs/wrapper'
import '@ica-azure/ica-elements/IcaTable'

type IcaTableProps = React.JSX.IntrinsicElements['tgdb-ica-table']

export interface HeaderItemClickDetail {
  label: string
  column: number
  sortdirection: string
  id: string
}

export const IcaTable = wrapWc<IcaTableProps & {
  onHeaderitemclick?: (e: CustomEvent<HeaderItemClickDetail>) => void
}>('tgdb-ica-table', ['headeritemclick'])